import styled from 'styled-components';

export const Row = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;
`;

export const Label = styled.span`
    width: 100%;
    font-weight: 700;
    font-size: 10px;
    line-height: 18px;
    letter-spacing: 1px;
    text-transform: uppercase;
    margin-top: 12px;
    color: ${({ theme }) => theme.colors.neutral700};
`;

interface SmallLabelType {
    margin: string;
}

export const SmallLabel = styled.span<SmallLabelType>`
    font-weight: 400;
    font-size: 10px;
    line-height: 18px;
    letter-spacing: 0.5px;
    color: ${({ theme }) => theme.colors.neutral700};
    margin: ${({ margin }) => margin || '0px'};
`;

export const InputWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    width: 100%;
    height: 54px;
`;

export const AlignWrapper = styled.div`
    display: flex;
    align-items: end;
`;
